const switchClientsRedirectPageActionTypes = {
  SET_USER_CLIENT_DETAILS: 'SET_USER_CLIENT_DETAILS',
  RESET_STATE: 'RESET_STATE',
};

export { switchClientsRedirectPageActionTypes as default };
